import { Component, Input, ViewChild } from '@angular/core';
import * as $ from 'jquery'

@Component({
  selector: 'rmt-content-loader',
  templateUrl: 'rmt-content-loader.html'
})
export class RmtContentLoaderComponent {
  @Input() isReady: boolean = false;
  @Input() show: boolean = true;
  @Input() showSpinner: boolean = true;  
  @Input() small: boolean = false;
  @Input() prevIsReady: boolean = false;
  @Input() autoplay: boolean = false;
  @Input() inline: boolean = false;
  @Input() skeleton: boolean = false;
  @Input() skeletonRows: number = 1;
  @ViewChild('content') content;
  animLoading;
  readyTimeout = null;
  
  constructor() {}

  ngAfterViewInit() {
    window.setTimeout(() => {
      this.animLoading = {
        path: 'assets/anims/ria-loader-coin.json',
        autoplay: false,
        loop: true
      };  
    });
  }
  
  ngAfterViewChecked() {       
    const div = this.content.nativeElement.childNodes[1];
    if (this.isReady) {      
      if (!this.prevIsReady) {
        div.style.maxHeight = 'none';
        const height = $(div).outerHeight();
        div.style.maxHeight = height + 'px';
        this.readyTimeout = window.setTimeout(() => {
          this.readyTimeout = null;
          if (this.isReady)
            div.style.maxHeight = 'none';
        }, 200);
      }      
    }
    else {      
      if (this.readyTimeout)
        window.clearTimeout(this.readyTimeout);
      div.style.maxHeight = '0px';
    }
    this.prevIsReady = this.isReady;
  }

  counter(i: number) {
    return new Array(i);
  }
}



// WEBPACK FOOTER //
// ./src/components/rmt-content-loader/rmt-content-loader.ts